import React, { useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FIREBASE_COLLECTION_DOC_KEY, FIREBASE_COLLECTION_KEY, ROUTE_PATHS } from "../../../constants";
import { getCurrentDayGames } from "../../../util";
import editIcon from "../images/edit.png";
import deleteIcon from "../images/delete_red.png";
import { updateCollection } from "../../../services/firebase";

const FatafatResultsCard = ({ isAdminLoggedIn, data = [], firebaseData = {} }) => {
  const navigate = useNavigate();
  const todaysGames = getCurrentDayGames(data);

  const onEditGame = useCallback((fatafatGuessId) => {
    navigate(`${ROUTE_PATHS.ADD_FATAFAT_RESULT}/${fatafatGuessId}`);
  }, [navigate]);

  const onDeleteFatafatTableAPICall = (body) => {
    // APIService.post(API_CONFIGS.DELETE_FATAFAT.URL, body)
    const source = firebaseData?.fatafatResults || data || [];
    const fatafatResults = source.filter(
      (item) => item?.fatafatGuessId !== body?.fatafatGuessId
    );
    updateCollection(FIREBASE_COLLECTION_KEY, FIREBASE_COLLECTION_DOC_KEY, {
      fatafatResults,
    })
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error deleting fatafat result from Firebase:", error);
        alert("Could not delete the fatafat result.");
      });
  };

  const onDelete = (body) => {
    if (window.confirm("Are you sure you want to delete this game?")) {
      // Save it!
      onDeleteFatafatTableAPICall(body);
    } else {
      // Do nothing!
      console.log("Thing was not deleted to the database.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="container">
        <div className="matka-results" style={{ paddingBottom: 0 }}>
          <h2>Shanti Fatafat</h2>
          <div className="test">
            {isAdminLoggedIn && (
              <div className="d-flex align-items-center test">
                {/* <img
                  className="img-btn"
                  src={editIcon}
                  title="Edit game"
                  alt="edit-game"
                  onClick={onEditGame}
                /> */}
                <Link
                  to={ROUTE_PATHS.ADD_FATAFAT_RESULT}
                  title="Add Fatafat Result"
                  className="add-fatafat-btn"
                >
                  <b>+</b>
                </Link>
              </div>
            )}
            <Link
              to={ROUTE_PATHS.FATAFAT_RESULT_DETAIL}
              title="Fatafat chart"
              className="shantiMatkaChartBtn"
            >
              Chart
            </Link>
          </div>
        </div>
        {todaysGames.length === 0 ? (
          <div className="shadow_card">
            <h1>No results available!</h1>
          </div>
        ) : (
          <div className="fatafat-card">
            <table>
              <tbody style={{ alignSelf: "baseline" }}>
                <tr>
                  <th>Round</th>
                  <th>Result</th>
                  {isAdminLoggedIn && <th></th>}
                </tr>
                {todaysGames.map((item, index) => (
                  <tr key={`fatafattable-${item?.fatafatGuessId}-${index}`}>
                    <td>{item.startTime}</td>
                    <td>
                      {item.guessNumber} - {item.winnerValue}
                    </td>
                    {isAdminLoggedIn && (
                      <td>
                        <div style={{ marginLeft: 10 }}>
                          <img
                            className="img-btn"
                            style={{ height: 25, width: 25 }}
                            src={editIcon}
                            title="Edit game"
                            alt="edit-game"
                            onClick={() => onEditGame(item.fatafatGuessId)}
                          />
                          <img
                            className="img-btn"
                            style={{ height: 25, width: 25 }}
                            src={deleteIcon}
                            title={`delete game`}
                            alt={`delete-game`}
                            onClick={() =>
                              onDelete({ fatafatGuessId: item.fatafatGuessId })
                            }
                          />
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
                {/* {todaysGames
                  .filter((_item, index) => index % 2 === 0)
                  .map((item, index) => (
                    <tr key={`fatafattable-${item?.fatafatGuessId}-${index}`}>
                      <td>{item.startTime}</td>
                      <td>
                        {item.guessNumber} - {item.winnerValue}
                      </td>
                    </tr>
                  ))} */}
              </tbody>
              {/* <tbody style={{alignSelf: 'baseline'}}>
                <tr>
                  <th>Round</th>
                  <th>Result</th>
                </tr>
                {todaysGames
                  .filter((_item, index) => index % 2 !== 0)
                  .map((item, index) => (
                    <tr key={`fatafattable-${item?.fatafatGuessId}-${index}`}>
                      <td>{item.startTime}</td>
                      <td>
                        {item.guessNumber} - {item.winnerValue}
                      </td>
                    </tr>
                  ))}
              </tbody> */}
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default FatafatResultsCard;
